import { gql } from '@apollo/client';

export const EVALUATE = gql`
  mutation Mutation($input: GenericExpressionForEvaluation) {
    evaluateGenericExpression(input: $input) {
      error
      evaluationResult
      evaluationVariables {
        variableName
        variableValue
      }
      genericDocumentInfo
      genericEntityId
      xmlFile
      identifier
    }
  }
`;
